import Vue from "vue";
import Router from "vue-router";
import readyCourse from "./ready-Course";
import giveCourse from "./give-Course";
import teachEffect from "./teach-Effect";

import { Loading, Message, MessageBox } from "element-ui";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: () => import("@/components/BaseLogin"),
      redirect: "/login",
      children: [
        {
          // 登录
          path: "/login",
          name: "login",
          component: () => import("@/components/BaseLogin")
        }
      ]
    },
    {
      path: "/home",
      name: "home",
      component: () => import("@/components/BaseHome")
    },
    {
      path: "/situation",
      name: "situation",
      component: () => import("@/views/situation/index")
    },
    {
      path: "/situationTwo",
      name: "situationTwo",
      component: () => import("@/views/situation/indexTwo")
    },
    // 修改后的学情分析
    {
      path: "/situationNew",
      name: "situationNew",
      component: () => import("@/views/situation/situationNew")
    },
    // 资源分析
    {
      path: "/resourceAnalysis",
      name: "resourceAnalysis",
      component: () => import("@/views/situation/resourceAnalysis")
    },
    // 课程信息
    {
      path: "/courseInfo",
      name: "courseInfo",
      component: () => import("@/views/situation/courseInfo")
    },
    // 学情分析
    {
      path: "/studentAnalysis",
      name: "studentAnalysis",
      component: () => import("@/views/situation/studentAnalysis")
    },
    // 个人画像
    {
      path: "/studentPortrayal",
      name: "studentPortrayal",
      component: () => import("@/views/situation/studentPortrayal")
    },
    // 专业
    {
      path: "/major",
      name: "major",
      component: () => import("@/views/situation/major")
    },
    {
      path: "/effect",
      name: "effect",
      component: () => import("@/views/effect/index")
    },
    {
      path: "/close",
      name: "close",
      component: () => import("@/views/give-course/components/close")
    },
    ...giveCourse,
    ...readyCourse,
    ...teachEffect
  ]
});

// vue相同路由跳转报错问题处理
const originalPush = Router.prototype.push;
// console.log(originalPush)
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

// 前置守卫
router.beforeEach((to, from, next) => {
  console.log(to);
  console.log(from);
  const szToken = window.localStorage.getItem("szToken");
  const jwToken = window.localStorage.getItem("jwToken");
  const token = window.localStorage.getItem("Authorization");
  if (from.fullPath == "/") {
    if (
      szToken ||
      jwToken ||
      token ||
      to.fullPath != "/ready/home" ||
      to.fullPath != "/give/home"
    ) {
      next();
    } else {
      Message.error({
        showClose: true,
        message: "登录信息无效，请重新登录"
      });
      setTimeout(() => {
        router.replace({
          name: "login",
          query: { redirect: router.currentRoute.fullPath } //登录后再跳回此页面时要做的配置
        });
      }, 500);
    }
  } else {
    if (to.name !== "login" && !token) {
      if (szToken || jwToken) {
        Message.error({
          showClose: true,
          message: "登录信息无效，请重新登录"
        });
        setTimeout(() => {
          window.close();
        }, 500);
      } else {
        next();
      }
    }
  }
  // 如果用户未能验证身份，则 `next` 会被调用两次
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js